class AdvancedFormCtrl {
  constructor($scope, $element, $window, TBService, FEService, SchemaService, AuthService, TemplateService, EventService, FlashService) {
    'ngInject';
    this.$element = $element;
    this.$window = $window;
    this.$scope = $scope;
    this.tb = TBService;
    this.ss = SchemaService;
    this.fe = FEService;
    this.as = AuthService;
    this.ts = TemplateService;
    this.fs = FlashService;
    this.es = EventService;

    this.isFile = false;
    this.PROVIDER = null;
    this.isImportingCdd = false;
    this.fieldSchema = {};
    this.label = 'Loading label...';
    this.invalidCss = false;
    this.initialized = false;
    this.filterFields = null;
    this.filterValueFields = [];

    this.reportSortColumns = [
      {
        'key': 'type',
        'header': '',
        'style': { "max-width": "30px", "width": "30px", "text-align": "center" },
        'format': (value) => value == 'Group' ? `<i class="fa fa-object-group text-muted" title="Group"></i>`: `<i class="fa fa-sort text-muted" title="Sort"></i>`,
      },
      {
        'key': 'field',
        'header': "Field"
      },
      {
        'key': 'direction',
        'style': { "max-width": "80px", "width": "80px" },
        'header': "Direction"
      }, 
      {
        'key': 'fId',
        'header': '',
        'style': { "max-width": "30px", "width": "30px" },
        'format': () => `<i class="fa fa-trash text-muted"></i>`,
        'onClick': (_, record) => this.deleteReportSort(record)
      }
    ];
  }
  
  async $onInit() {
    const waitBindings = ["token"];
    [this.td, this.PROVIDER] = await Promise.all([
      this.ts.getTemplateData(),
      this.as.getProviderSettings(),
      this.fe.waitForBindings(waitBindings, this.$scope)
    ]);
    
    const reference = this.td.template.references.find( r => r.id === this.token.referenceId);
    const { tableId } = reference;
    this.schema = await this.ss.getSchema(this.td.template, tableId);
    this.tokenSchema = this.schema;
    this.newTokenRef = reference;

    const fieldId = this.fe.getFieldId(this.token.fieldId);
    this.fieldSchema = this.schema.fields.find(f => `${f.id}` === `${fieldId}`);
    this.isCustomKey = this.fieldSchema.isPrimaryKey && this.fieldSchema.fieldType === 'text';
    this.isFile = this.fieldSchema.isFile;
    this.isDynamic = this.td.template.type === 'dynamic';
    // User must use ckeditor tools to set these styles (dynamic templates) or tokens can break:
    this.invalidProps = this.isDynamic ? ["font-style", "font-weight"] : [];
    this.isEmbeddable = !this.isDynamic && !!this.token.control.embedUrlType;
    this.isReportField = this.isDynamic && this.PROVIDER.reportFields.includes(this.fieldSchema.fieldType);
    this.initLabel();
    this.initFieldConfigControls();
    this.initOptionsControls();
    this.initBorderedControls();
    this.initUploadType();
    this.initMetadataControls();
    this.initForeignFields();
    this.initSignatureFeatures();
    this.initTokenFlags();
    this.initialized = true;
    this.isReportField && this.initReportOptions();
    this.fieldSchema.isForeignKey && this.setFilterFields();

    const wFormat = this.$scope.$watch('$ctrl.token.format', (newFormat, oldFormat) => {
      (newFormat !== oldFormat) && this.setFormatLayout(newFormat);
    });

    this.$scope.$on('$destroy', () => { wFormat() });
  }

  initForeignFields() {
    if (!this.fieldSchema.isForeignKey) return;
    this.availableFkFields = this.schema.foreignKeys
      .find(k => k.fieldId == this.token.fieldId).defaultFields
      .map(f => { return { id: f.id, label: f.label, fieldType: f.fieldType } });
    if (this.token.options?.selectFieldIds === undefined) {
      const selectFieldIds = this.availableFkFields.slice(0, 5).map(f => f.id);
      this.token.options = {...this.token.options, selectFieldIds};
    }
    this.token.options.filter = { pageSize: "10", ...(this.token.options.filter || {})};
  }

  initSignatureFeatures() {
    const signFeats = this.token.options?.signatureFeatures || [];
    if (signFeats.length === 0) {
      this.signatureMode = "all";
    } else if (signFeats.length === 1 && signFeats[0] === "drawpad") {
      this.signatureMode = "onlyPad";
    } else if (signFeats.length === 1 && signFeats[0] === "keyboard") {
      this.signatureMode = "onlyKeyboard";
    } else {
      this.signatureMode = "all"; // default fallback
    }
  }

  initTokenFlags() {
    this.ts.setTokenBehaviorsFlag(this.token);
  }

  initFieldConfigControls() {
    this.isConfigurable = true; // disable config section for some fields?
    this.token.fieldSchema = this.schema.fields.find(f => f.id == this.token.fieldSchema.id);
    this.showAdjustFontToFit = ['text-control', 'textarea-control'].includes(this.token.control?.type) && !this.isDynamic;
    this.isUrlField = this.fieldSchema && ['url', 'formula_url'].includes(this.fieldSchema.fieldType);
  }

  initMetadataControls() {
    this.geoDataConfig = this.PROVIDER.geoLocationFields.find(c => c.field === this.fieldSchema.fieldType );
    this.hasMetadata = this.geoDataConfig !== undefined;
  }

  initOptionsControls() {
    this.showRadio = this.token.control.type === 'select-control';
    this.showMultiCheckbox = this.token.control.type === 'multiselect-control';
    this.showChildOpts = this.showRadio || this.showMultiCheckbox;
    this.childOptsType = this.showChildOpts ? (this.showRadio ? 'Radio' : 'Checkbox') : null;
  }

  initUploadType() {
    if (this.isFile && !this.token.format) this.token.format = '';
  }

  initBorderedControls() {
    if (!['radio-control'].includes(this.token.control.type)) return;
    this.showBorderConfig = true;
    this.token.options = this.token.options || {};
    if (this.token.options.hideBorder === undefined)
      this.token.options.hideBorder = this.isDynamic ? false : true;
  }
  
  initLabel() {
    const options = this.token.options;
    this.originalLabel =  this.fieldSchema.label;
    this.label = (typeof options?.label === 'string') ? options.label : this.fieldSchema.label;
    this.isRadio = !!this.token.options?.choice && ['radio-control'].includes(this.token.control.type);
    this.isMultiCheckbox = !!this.token.options?.choice && ['multicheckbox-control'].includes(this.token.control.type);
    this.isOption = this.isRadio || this.isMultiCheckbox;
  }

  initReportOptions() {
    this.token.options = this.token.options || {};
    this.token.options.groupings = this.token.options.groupings || [];
    this.token.options.filters = this.token.options.filters || [{ operator: "==", type: "static" }];
    this.token.options.sortBy = this.token.options.sortBy || [];
    this.origReportOptions = { ...this.reportOptions };
    this.reportFields = this.token.control.reportTableSchema.fields;
    this.availReportFields = this.reportFields
      .map(f => { return { id: f.id, label: f.label } });
    this.availReportGroupFields = this.reportFields
      .filter(f => this.PROVIDER.sortFields.includes(f.fieldType))
      .map(f => { return { id: f.id, label: f.label } })
      .sort((a,b) => a.label.localeCompare(b.label));
    this.loadReportSortRecs();
  }

  addReportSort(event) {
    event.preventDefault();
    if (this.token.options.sortBy.length === 3) {
      this.fs.error("No more than 3 sort fields are allowed!");
      return;
    }
    if (this.token.options.sortBy.some(s => s.fieldId === this.reportSortField)) {
      this.fs.error("The field was already used for sorting!");
      return;
    }
    this.token.options.sortBy.push({ fieldId: this.reportSortField, order: this.reportSortDirection });
    this.loadReportSortRecs();
    this.reportSortDirection = undefined;
    this.reportSortField = undefined;
    
  }

  loadReportSortRecs() {
    this.reportSortRecs = [];
    this.reportSortRecs.push(...this.token.options.sortBy.map(s => {
      const field = this.reportFields.find(f => f.id == s.fieldId);
      return { field: field.label, fId: field.id, direction: s.order };
    }));
  }

  deleteReportSort(rec) {
    this.token.options.sortBy = this.token.options.sortBy.filter(o => o.fieldId != rec.fId || o.order != rec.direction);
    this.loadReportSortRecs();
  }
  
  changeLabel(label = '') {
    this.token.options = {...this.token.options, label};
  }

  async changeReference() {
    this.tokenSchema = await this.ss.getSchema(this.td.template, this.newTokenRef.tableId);
    this.token.fieldSchema = null;
    this.token.referenceId = this.newTokenRef.id;
  }

  updateTokenCss(css) {
    this.es.dispatchEvent(
      this.es.actions.ELEMENT_STYLE_UPDATED, 
      css);
  }
  
  async setFormatLayout(format) {
    this.invalidCss = true;
    const { token, fieldSchema, "td": {template} } = this;
    let height, width, defaultCss = {};
    this.resetTokenCss(token);
    if (token.options?.originalSize) token.options.originalSize = false;
    switch (format) {
      case 'image':
        [height, width] = ['15vw', '30%'];
        defaultCss = {'text-align': 'center', 'font-family': 'inherit'};
        break;
      case 'signature':
        [height, width] = ['7vw', '35%'];
        defaultCss = {'text-align': 'center', 'font-family': "'Pinyon Script'"};
        break;
      default:
        [height, width] = ['4.6vw', '25%'];
        defaultCss = {'text-align': 'inherit', 'font-family': 'inherit'};
        break;
    }
    
    token.format = format;

    let controls;
    try {
      ({ data: {controls} } = await this.ts.fetchControls([token]));
    }
    catch(error) {
      this.fs.error(error.message);
      return;
    }
    token.control = controls[0];

    let newCss = this.tb.getResizeCss(token, {height, width}, fieldSchema);

    if (this.isDynamic) {
      if (['image', 'signature'].includes(format)) {
        const pageDims = this.tb.getDynamicPageDims(this.td.template.layout);
        newCss = { ...newCss, ...this.tb.getDynamicTokenDims(pageDims, newCss) };
      }
      else {
        newCss = {};
        defaultCss = {...defaultCss, ...{ width: '', height: '', "font-size": 'inherit', "line-height": 'inherit'}};
      }
    } 

    this.updateTokenCss({...newCss, ...defaultCss});
  }
  
  async createChildOpts(oldToken) {
    const { template, template: { behaviors, conditions } } = this.td;
    const { choices } = oldToken.control;
    const msg = `Are you sure? This will add ${choices.length} Fields to the form as ${this.childOptsType} Options.\nNote: any Field Behaviors for this field, or Behaviors that depend on this field, will be removed and need to be recreated after the change to  ${this.childOptsType} options!`;
    if (!this.$window.confirm(msg)) return;
    let top, height, width, newTop;

    if (!this.isDynamic) {
      top = this.parseLayout("top", '%', oldToken);
      height = this.parseLayout("height", 'vw', oldToken);
      width = this.parseLayout("width", '%', oldToken);
      newTop = parseFloat(top);
    }
    const updatedTokens = choices.map((choice) => this.ts.copyToken({...oldToken, 'options': {choice}}));
    
    let controls;
    try {
      ({ data: {controls} } = await this.ts.fetchControls(updatedTokens));
    }
    catch(error) {
      this.fs.error(error.message);
      return;
    }

    const newTokens = updatedTokens.map((token, i) => {
      const newToken = this.ts.initializeNewObject({...token, control: controls[i]});

      if (!this.isDynamic) {
        newToken.layout = newToken.layout
          .replace(`width: ${width}%`, `width: ${height}vw`)
          .replace(`top: ${top}`, `top: ${newTop}`);
        newTop = Math.min(newTop + 3, 95);
      }
      
      return newToken;
    });

    const newBehaviors = [], newConditions = [];
    newTokens.forEach(newToken => {
      behaviors.filter(b => b.childId === oldToken.id).forEach(behavior => {
        const newBehavior = this.ts.initializeNewObject({...behavior});
        newBehavior.childId = newToken.id;
        newBehaviors.push(newBehavior);
        conditions.filter(c => c.behaviorId === behavior.id).forEach(condition => {
          const newCondition = this.ts.initializeNewObject({...condition});
          newCondition.childId = newToken.id;
          newCondition.behaviorId = newBehavior.id;
          newConditions.push(newCondition);
        });
      });
    });
    
    template.tokens.push(...newTokens);
    template.behaviors.push(...newBehaviors);
    template.conditions.push(...newConditions);
    const extra = { replaceToken: { newTokens: newTokens.map(({id}) => id), oldToken: oldToken.id } };
    this.ts.notifyUpdate(["tokens", "behaviors", "conditions"], this.td, false, extra );

    this.es.dispatchEvent(this.es.actions.TOKEN_REMOVE, {token: oldToken});
  }
  
  async toggleEmbedUrl(token = {}){
    let options = token.options || {};
    options.embedUrlType = options.embedUrlType ? null : token.control.embedUrlType;
    token.options = options;
    this.resetTokenCss(token);
    if(options.embedUrlType) {
      const css = { height: '30vw', 'line-height': '30vw' };
      this.applyTokenCss(token, css);
    }

    const newCss = this.tb.getCssObj(token.layout);
    this.updateTokenCss(newCss);
    
    const { data: {controls} } = await this.ts.fetchControls([token]);
    token.control = controls[0];
  } 

  applyTokenCss(token, css) {
    !this.isDynamic && this.tb.safeApplyTokenCss(token, css);
  }

  resetTokenCss(token) {
    !this.isDynamic && this.tb.resetCss(token);
  }
  
  parseLayout(attr, unit) {
    return this.style.split(`${attr}: `)[1].split(unit)[0];
  }

  updateSignatureSettings() {
    let signatureFeatures = [];
    if (this.signatureMode === "onlyPad") {
      signatureFeatures = ["drawpad"];
    } else if (this.signatureMode === "onlyKeyboard") {
      signatureFeatures = ["keyboard"];
    }
    this.token.options = { ...this.token.options, signatureFeatures };
  }

  setFilterFields() {
    this.token.options ??= {};
    this.token.options.filter ??= {};
    this.filterFields = this.getFilterFields(this.availableFkFields);
  }

  setFilterValueFields(reset) {
    if (reset) delete this.token.options.filter.valueFid;
    const ref = this.td.template.references.find(r => r.id == this.token.options.filter.referenceId);
    this.filterValueFields = this.getFilterFields(ref?.tableSchema?.fields);
  }

  getFilterFields(fields) {
    return (fields || [])
      .filter(f => this.PROVIDER.sortFields.includes(f.fieldType))
      .map(f => { return { id: f.id, label: f.label } })
      .sort((a,b) => a.label.localeCompare(b.label));
  }
}

export default {
  bindings: {
    token: "=",
    style: "=",
    section: "=",
    invalidCss: "=",
    reportOptions: "=",
    configOptions: "=",
  },
  templateUrl: "form-builder/forms/advanced-form/advanced-form.component.html",
  controller: AdvancedFormCtrl

}